;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import styles from "../TherapistsPage.module.css"

export type SkeletonLoaderProps = {
  type?:
    | "features"
    | "superpowers"
    | "referrals"
    | "pricing"
    | "advertise"
    | "discover"
}

export default function SkeletonLoader(_props: SkeletonLoaderProps = {}) {
  return (
    <div className={styles.skeletonSection}>
      <div className={styles.skeletonHeader}></div>
      <div className={styles.skeletonContent}>
        <div className={styles.skeletonCard}></div>
        <div className={styles.skeletonCard}></div>
        <div className={styles.skeletonCard}></div>
      </div>
    </div>
  )
}
